
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const UserCenterPage = lazy(() => import('../pages/user-center/page'));
const RegisterNFTPage = lazy(() => import('../pages/register-nft/page'));
const VerifyPage = lazy(() => import('../pages/verify/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const NFTDetailPage = lazy(() => import('../pages/nft-detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/user-center',
    element: <UserCenterPage />,
  },
  {
    path: '/register-nft',
    element: <RegisterNFTPage />,
  },
  {
    path: '/verify',
    element: <VerifyPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/nft-detail',
    element: <NFTDetailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
